export class AsyncHelper {
  static wait(ms) {
      return new Promise<any>(resolve => {
          setTimeout(() => resolve(), ms);
      });
  }

  static async waitFor(condition: () => boolean, ms = 0, sleep = 100) {
      let timeout = ms;
      const hasTimeout = (ms > 0);

      while (!condition()) {
          await this.wait(sleep);

          if (hasTimeout) {
              timeout -= sleep;
              if (timeout <= 0) {
                  return false;
              }
          }
      }

      return true;
  }

  static retryWithDelay<T>(generator: Function, retries: number, delay: number = 0) {
      return new Promise<T>((resolve, reject) => {
          const p: Promise<T> = generator();

          p.then(result => {
              resolve(result);
          }, err => {
              if (retries === 0) {
                  reject(err);
              }
              else if (delay > 0) {
                  setTimeout(() => AsyncHelper.retryWithDelay<T>(generator, retries - 1, delay).then(data => resolve(data), err => reject(err)), delay);
              }
              else {
                  AsyncHelper.retry<T>(generator, retries - 1).then(data => resolve(data), err => reject(err));
              }
          });
      });
  }

  static retry<T>(generator: Function, retries: number) {
      return new Promise<T>((resolve, reject) => {
          const p: Promise<T> = generator();

          p.then(result => {
              resolve(result);
          }, err => {
              if (retries === 0) {
                  reject(err);
              }
              else {
                  AsyncHelper.retry<T>(generator, retries - 1).then(data => resolve(data), err => reject(err));
              }
          });
      });
  }

  static runWithTimeout<T>(promise: Promise<T>, timeout: number, error: string = null) {
      let timeoutId = null;
      const timeoutPromise = new Promise<T>((resolve, reject) => {
          timeoutId = setTimeout(() => {
              timeoutId = null;
              reject(error || "Timeout");
          }, timeout);
      });

      const successPromise = new Promise<T>((resolve, reject) => {
          promise.then(result => {
              if (timeoutId) {
                  clearTimeout(timeoutId);
                  resolve(result);
              }
              else {
                  reject();
              }
          }, err => {
              reject(err);
          });
      });

      return Promise.race<T>([successPromise, timeoutPromise]);
  }
}
